import React, {useRef, useState, useEffect} from 'react';
import {Button, Card, Form, Row, Col} from 'react-bootstrap';
import Select from 'react-select';
import {PfButton} from '@profabric/react-components';
import {toast} from 'react-toastify';

export default function ModalAddCar(props) {
  const [file, setFile] = useState([
    {id: 1, file: null},
    {id: 2, file: null}
  ]);
  const [error, setError] = useState('');
  const [state, setState] = useState({
    Brand: '',
    VehicleType: '',
    Model: '',
    EngineCC: '',
    FuelType: '',
    RegisNumber: '',
    RegisProvince: ''
  });

  // 💡 2. แยก State สำหรับพรีวิวรูปรถ และ รูปเล่มทะเบียนออกจากกัน
  const [previewCar, setPreviewCar] = useState('');
  const [previewDoc, setPreviewDoc] = useState('');

  useEffect(() => {
    if (props.editItem) {
      console.log("แก้ไขข้อมูลรถเก่า:", props.editItem);
      setState({
        VehicleId: props.editItem.VehicleId, 
        Brand: props.editItem.Brand || '',
        VehicleType: props.editItem.VehicleType || '',
        Model: props.editItem.Model || '',
        EngineCC: props.editItem.EngineCC || '',
        FuelType: props.editItem.FuelType || '',
        RegisNumber: props.editItem.RegisNumber || '',
        RegisProvince: props.editItem.RegisProvince || ''
      });
      
      // 💡 ดึงรูปเดิมจากระบบ (Url และ Url2) มาตั้งต้นเป็นรูปพรีวิว
      setPreviewCar(props.editItem.Url || '');
      setPreviewDoc(props.editItem.Url2 || '');
      setError('');
    } else {
      setState({
        Brand: '',
        VehicleType: '',
        Model: '',
        EngineCC: '',
        FuelType: '',
        RegisNumber: '',
        RegisProvince: ''
      });
      setPreviewCar('');
      setPreviewDoc('');
      setFile([
        {id: 1, file: null},
        {id: 2, file: null}
      ]);
      setError('');
    }
  }, [props.editItem]);

  const handleValidation = () => {
    let errors = '';
    let formIsValid = true;

    if (state.Brand === '') {
      formIsValid = false;
      errors = errors + 'ยี่ห้อ, ';
    }
    if (state.VehicleType === '') {
      formIsValid = false;
      errors = errors + 'ประเภท, ';
    }
    if (state.Model === '') {
      formIsValid = false;
      errors = errors + 'รุ่น, ';
    }
    if (state.EngineCC === '') {
      formIsValid = false;
      errors = errors + 'ขนาด, ';
    }
    if (state.FuelType === '') {
      formIsValid = false;
      errors = errors + 'เชื้อเพลิง, ';
    }
    
    if (!props.editItem) {
      if (file[0].file === null) {
        formIsValid = false;
        errors = errors + 'รูปรถ, ';
      }
      if (file[1].file === null) {
        formIsValid = false;
        errors = errors + 'รูปเล่ม, ';
      }
    }
    
    if (state.RegisNumber === '') {
      formIsValid = false;
      errors = errors + 'ทะเบียน, ';
    }
    if (state.RegisProvince === '') {
      formIsValid = false;
      errors = errors + 'จังหวัด, ';
    }

    if (!formIsValid) setError(`Required: ${errors}`);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (handleValidation()) {
      setLoading(true);
      try {
        console.log("ส่งค่าไปเซฟ:", state);
        const finalFiles = [
          file[0].file, // รูปรถ (จะวิ่งไปเข้า filesName[0] ที่หลังบ้าน)
          file[1].file  // รูปเล่ม (จะวิ่งไปเข้า filesName[1] ที่หลังบ้าน)
        ];
        const result = await props.onAdd(state, finalFiles);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const photoUpload = async (e, id) => {
    e.preventDefault();
    const _file = e.target.files[0];
    
    if (_file) {
      // 💡 จุดดักเช็กขนาดไฟล์: 2 MB = 2,097,152 Bytes
      const maxFileSize = 2 * 1024 * 1024; 
      if (_file.size > maxFileSize) {
        // แจ้งเตือนผู้ใช้ด้วย Toast สีแดงทันที
        toast.error('❌ ไฟล์รูปภาพมีขนาดใหญ่เกิน 2 MB กรุณาเลือกรูปใหม่ที่มีขนาดเล็กลงครับ');
        
        // เคลียร์ค่าใน input element ของตัวที่เลือกพลาด เพื่อให้ผู้ใช้กดเลือกใหม่ได้
        e.target.value = null; 
        return; // สั่งหยุดการทำงานทันที ไม่ให้แปลงเป็น base64 หรือเซ็ตลง State
      }
      // 🟢 ถ้าขนาดไฟล์ผ่านเกณฑ์ (ไม่เกิน 2 MB) ให้ทำงานต่อตามปกติ
      let base64 = await convertToBase64(_file);
      
      if (id === 1) {
        setPreviewCar(base64);
      } else if (id === 2) {
        setPreviewDoc(base64);
      }

      const temp = file.map((e) => {
        if (e.id === id) return {...e, file: _file};
        else return e;
      });
      setFile(temp);
    }
  };

  const [isLoading, setLoading] = useState(false);

  const selectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: '8px',
      borderColor: '#dee2e6',
      minHeight: '38px',
      boxShadow: 'none',
      '&:hover': {borderColor: '#007bff'}
    }),
    menuPortal: (base) => ({...base, zIndex: 9999})
  };

  return (
    <div className="p-1">
      <Form>
        <Row className="g-3">
          {/* แถวที่ 1: ยี่ห้อ และ ประเภท */}
          <Col md={6}>
            <Form.Label className="small fw-bold text-muted">ยี่ห้อรถยนต์</Form.Label>
            <Select
              menuPortalTarget={document.body}
              styles={selectStyles}
              placeholder="เลือกยี่ห้อ..."
              options={props.dropdownsMaster.filter((e) => e.type === 'Brand')}
              value={props.dropdownsMaster.filter((e) => e.type === 'Brand').find((v) => v.value == state.Brand)}
              onChange={(v) => setState((p) => ({...p, Brand: v.value}))}
            />
          </Col>
          <Col md={6}>
            <Form.Label className="small fw-bold text-muted">ประเภทรถ</Form.Label>
            <Select
              menuPortalTarget={document.body}
              styles={selectStyles}
              placeholder="เลือกประเภท..."
              options={props.dropdownsMaster.filter((e) => e.type === 'VehicleType')}
              value={props.dropdownsMaster.filter((e) => e.type === 'VehicleType').find((v) => v.value == state.VehicleType)}
              onChange={(v) => setState((p) => ({...p, VehicleType: v.value}))}
            />
          </Col>

          {/* แถวที่ 2: รุ่น, ขนาด, เชื้อเพลิง */}
          <Col md={4}>
            <Form.Label className="small fw-bold text-muted">รุ่น</Form.Label>
            <Form.Control
              style={{borderRadius: '8px'}}
              type="text"
              placeholder="เช่น Civic, Hilux"
              value={state.Model}
              onChange={(e) => setState((p) => ({...p, Model: e.target.value}))}
            />
          </Col>
          <Col md={3}>
            <Form.Label className="small fw-bold text-muted">ขนาด (cc)</Form.Label>
            <Form.Control
              style={{borderRadius: '8px'}}
              type="number"
              placeholder="1500"
              value={state.EngineCC}
              onChange={(e) => setState((p) => ({...p, EngineCC: e.target.value}))}
            />
          </Col>
          <Col md={5}>
            <Form.Label className="small fw-bold text-muted">เชื้อเพลิง</Form.Label>
            <Select
              menuPortalTarget={document.body}
              styles={selectStyles}
              placeholder="เลือกเชื้อเพลิง..."
              options={props.dropdownsMaster.filter((e) => e.type === 'FuelType')}
              value={props.dropdownsMaster.filter((e) => e.type === 'FuelType').find((v) => v.value == state.FuelType)}
              onChange={(v) => setState((p) => ({...p, FuelType: v.value}))}
            />
          </Col>

          {/* ส่วนอัปโหลดไฟล์ */}
          <Col md={12} className="mt-4">
            <h6 className="fw-bold border-bottom pb-2 mb-3">
              เอกสารและรูปถ่าย {props.editItem && <span className="text-primary small">(ข้ามได้หากใช้รูปเดิม)</span>}
            </h6>
          </Col>

          {/* 💡 ปรับปรุงดีไซน์กล่องอัปโหลดรูปภาพและการแสดงพรีวิวแยกกัน */}
          <Col md={12}>
            {/* 1. ส่วนของรูปรถ */}
            <Row className="align-items-start mb-4">
              <Col xs={3}>
                <div className="d-flex flex-column gap-2">
                  <a href="https://api-passport.advanceagro.net/img/car_sample.jpg" target={'_blank'} rel="noreferrer">
                    <Button variant="outline-secondary" size="sm" className="w-100 rounded-pill mb-2" style={{fontSize: '11px'}}>
                      ตัวอย่างรูปรถ
                    </Button>
                  </a>
                  
                  {/* แสดงกล่องพรีวิวรูปรถดั้งเดิม/รูปใหม่ตรงนี้ */}
                  <Card className="border shadow-sm rounded-3 overflow-hidden text-center" style={{backgroundColor: '#f8f9fa'}}>
                    <div style={{height: '160px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      {previewCar ? (
                        <img src={previewCar} style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain'}} alt="car preview" />
                      ) : (
                        <span className="text-muted" style={{fontSize: '14px'}}>ไม่มีรูป</span>
                      )}
                    </div>
                  </Card>
                </div>
              </Col>
              <Col xs={9}>
                <Form.Label className="small text-muted mb-1 fw-bold">รูปรถยนต์</Form.Label>
                <div className="custom-file shadow-sm rounded" style={{overflow: 'hidden'}}>
                  <input type="file" onChange={(e) => photoUpload(e, 1)} className="custom-file-input" accept=".jpeg, .png, .jpg" id="fileCar" />
                  <label className="custom-file-label m-0 border-0" htmlFor="fileCar">
                    {file[0].file ? `✅ ${file[0].file.name}` : props.editItem ? '📷 คลิกเพื่อ "เปลี่ยนรูปรถใหม่"' : 'คลิกเพื่อเลือกรูปรถ (ไม่เกิน 2MB)'}
                  </label>
                </div>
              </Col>
            </Row>

            {/* 2. ส่วนของรูปเล่มทะเบียน */}
            <Row className="align-items-start mb-4">
              <Col xs={3}>
                <div className="d-flex flex-column gap-2">
                  <a href="https://api-passport.advanceagro.net/img/car_doc_sample.jpg" target={'_blank'} rel="noreferrer">
                    <Button variant="outline-secondary" size="sm" className="w-100 rounded-pill mb-2" style={{fontSize: '11px'}}>
                      ตัวอย่างเล่ม
                    </Button>
                  </a>
                  
                  {/* แสดงกล่องพรีวิวรูปเล่มทะเบียนตรงนี้ */}
                  <Card className="border shadow-sm rounded-3 overflow-hidden text-center" style={{backgroundColor: '#f8f9fa'}}>
                    <div style={{height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      {previewDoc ? (
                        <img src={previewDoc} style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain'}} alt="doc preview" />
                      ) : (
                        <span className="text-muted" style={{fontSize: '10px'}}>ไม่มีรูป</span>
                      )}
                    </div>
                  </Card>
                </div>
              </Col>
              <Col xs={9}>
                <Form.Label className="small text-muted mb-1 fw-bold">รูปเล่มทะเบียนรถ</Form.Label>
                <div className="custom-file shadow-sm rounded" style={{overflow: 'hidden'}}>
                  <input type="file" onChange={(e) => photoUpload(e, 2)} className="custom-file-input" accept=".jpeg, .png, .jpg" id="fileDoc" />
                  <label className="custom-file-label m-0 border-0" htmlFor="fileDoc">
                    {file[1].file ? `✅ ${file[1].file.name}` : props.editItem ? '📷 คลิกเพื่อ "เปลี่ยนรูปเล่มทะเบียนใหม่"' : 'คลิกเพื่อเลือกรูปเล่มทะเบียน (ไม่เกิน 2MB)'}
                  </label>
                </div>
              </Col>
            </Row>
          </Col>

          {/* แถวที่ 3: ทะเบียน และ จังหวัด */}
          <Col md={6}>
            <Form.Label className="small fw-bold text-muted">หมายเลขทะเบียน</Form.Label>
            <Form.Control
              style={{borderRadius: '8px', fontWeight: 'bold', fontSize: '1.1rem'}}
              className="text-primary text-uppercase"
              type="text"
              value={state.RegisNumber}
              onChange={(e) => setState((p) => ({...p, RegisNumber: e.target.value}))}
              placeholder="1กข 1234"
            />
          </Col>
          <Col md={6}>
            <Form.Label className="small fw-bold text-muted">จังหวัด</Form.Label>
            <Select
              menuPortalTarget={document.body}
              styles={selectStyles}
              placeholder="เลือกจังหวัด..."
              options={props.dropdownsMaster.filter((e) => e.type === 'Province')}
              value={props.dropdownsMaster.filter((e) => e.type === 'Province').find((v) => v.value == state.RegisProvince)}
              onChange={(v) => setState((p) => ({...p, RegisProvince: v.value}))}
            />
          </Col>
        </Row>
      </Form>

      <div className="mt-4">
        {error && <div className="alert alert-danger py-2 small mb-3">{error}</div>}
        <PfButton
          className="shadow"
          theme={props.editItem ? "warning" : "success"}
          block
          loading={isLoading}
          type="button"
          onClick={handleSubmit}
          style={{borderRadius: '12px', height: '48px', fontSize: '1.1rem', fontWeight: 600}}
        >
          <i className={props.editItem ? "fas fa-save me-2" : "fas fa-plus-circle me-2"}></i> 
          {props.editItem ? "💾 บันทึกการแก้ไขข้อมูลรถ" : "ลงทะเบียนเพิ่มรถ"}
        </PfButton>
      </div>
    </div>
  );
}